import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";

import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoutes";
import ProviderProtectedRoute from "./pages/ProviderProtectedRoute";

// Public Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import PropertyCare from "./pages/PropertyCare";
import ParentalCare from "./pages/ParentalCare";
import Celebrate from "./pages/Celebrate";
import FinancialAdvisory from "./pages/FinancialAdvisory";
import TravelServices from "./pages/TravelServices";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import HelpCenter from "./pages/HelpCenter";
import FAQ from "./pages/FAQ";

// Protected Pages
import Dashboard from "./pages/Dashboard";
import RequestService from "./pages/RequestService";
import Profile from "./pages/Profile";
import Scheduling from "./pages/Scheduling";
import Checkout from "./pages/Checkout";
import Appointments from "./pages/Appointments";
import ChatInterface from "./pages/ChatInterface";
import ServiceStatus from "./pages/servicestatus";
import PaymentSuccess from "./pages/Paymentsuccess";
import OrderConfirmation from "./pages/OrderConfirmation";
import NriBuddyChatbot from "./pages/Chatbot";
import RequestDetails from "./pages/RequestDetails";
import AdminCustomerDetails from "./pages/AdminCustomerDetails";


// Admin
import Analytics from "./pages/Analytics";
import UserManagement from "./pages/UserManagement";

// Provider
import ProviderLogin from "./pages/ProviderLogin";
import ProviderDashboard from "./pages/ProviderDashboard";

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />

      <Routes>

        {/* PUBLIC ROUTES WITH HEADER & FOOTER */}
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />

        <Route
          path="/about"
          element={
            <Layout>
              <About />
            </Layout>
          }
        />

        <Route
          path="/services"
          element={
            <Layout>
              <Services />
            </Layout>
          }
        />

        <Route
          path="/property-care"
          element={
            <Layout>
              <PropertyCare />
            </Layout>
          }
        />

        <Route
          path="/parental-care"
          element={
            <Layout>
              <ParentalCare />
            </Layout>
          }
        />

        <Route
          path="/celebrate"
          element={
            <Layout>
              <Celebrate />
            </Layout>
          }
        />

        <Route
          path="/financial-advisory"
          element={
            <Layout>
              <FinancialAdvisory />
            </Layout>
          }
        />

        <Route
          path="/travel-services"
          element={
            <Layout>
              <TravelServices />
            </Layout>
          }
        />

        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />

        <Route
          path="/terms-and-conditions"
          element={
            <Layout>
              <TermsAndConditions />
            </Layout>
          }
        />

        <Route
          path="/help-center"
          element={
            <Layout>
              <HelpCenter />
            </Layout>
          }
        />

        <Route
          path="/faq"
          element={
            <Layout>
              <FAQ />
            </Layout>
          }
        />

        {/* AUTH PAGES WITHOUT LAYOUT */}
        <Route path="/login" element={<Login />} />

        <Route
          path="/provider/login"
          element={<ProviderLogin />}
        />

        {/* USER PROTECTED ROUTES WITHOUT LAYOUT */}
        <Route
  path="/dashboard"
  element={
    <Layout showFooter={false}>
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    </Layout>
  }
/>

        <Route
          path="/request-service"
          element={
            <ProtectedRoute>
              <RequestService />
            </ProtectedRoute>
          }
        />

        <Route
          path="/request/:id"
          element={
            <ProtectedRoute>
              <RequestDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route
  path="/admin/customer/:userId"
  element={
    <ProtectedRoute>
      <AdminCustomerDetails />
    </ProtectedRoute>
  }
/>

        <Route
          path="/scheduling"
          element={
            <ProtectedRoute>
              <Scheduling />
            </ProtectedRoute>
          }
        />

        <Route
          path="/checkout"
          element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          }
        />

        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <ChatInterface />
            </ProtectedRoute>
          }
        />

        <Route
          path="/service-status"
          element={
            <ProtectedRoute>
              <ServiceStatus />
            </ProtectedRoute>
          }
        />

        <Route
          path="/payment-success"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />

        <Route
          path="/order-confirmation"
          element={
            <ProtectedRoute>
              <OrderConfirmation />
            </ProtectedRoute>
          }
        />


        <Route
          path="/appointments"
          element={
            <ProtectedRoute>
              <Appointments />
            </ProtectedRoute>
          }
        />

        <Route
          path="/chatbot"
          element={
            <ProtectedRoute>
              <NriBuddyChatbot />
            </ProtectedRoute>
          }
        />

        {/* PROVIDER */}
        <Route
          path="/provider-dashboard"
          element={
            <ProviderProtectedRoute>
              <ProviderDashboard />
            </ProviderProtectedRoute>
          }
        />

        {/* ADMIN */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/analytics"
          element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          }
        />

      </Routes>
    </AuthProvider>
  );
}

export default App;